import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderComponent } from '../header/header.component';
import { MenuComponent } from '../menu/menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { MenuAdminComponent } from '../menuAdmin/menuadmin.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
*   Module pour utiliser des components sur plusieurs pages
*   Importer les components et les mettre dans declarations
*   Importer SharedModule dans les modules des pages
*/
@NgModule({
    declarations: [
    	HeaderComponent,
        MenuComponent,
        MenuAdminComponent
	],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxPaginationModule,
        FontAwesomeModule
    ],
    exports: [
        HeaderComponent,
        MenuComponent,
        MenuAdminComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxPaginationModule
    ],
})
export class SharedModule { }
